export default "https://assets.egbcdn.net/assets/packs/_/sounds/poker/fold-948181cbc552adeaf4f35ae41d5cb7b2.mp3";